<template>
    <RPBaseStatCard
        :title="title"
        :status="status"
        :card-link="cardLink"
        :card-link-text="cardLinkText"
        :border-color="borderColor"
        :background="background"
        @nav="n => $emit('nav', n)"
    >
        <template v-slot:title>
            <slot name="title"></slot>
        </template>
        <template v-slot:action>
            <slot name="action"></slot>
        </template>

        <template v-slot:content>
            <div class="StatCard">
                <slot name="primaryInfo">
                    <h1 class="StatCard__primary-info">
                        {{ primaryInfo }}
                    </h1>
                </slot>

                <slot
                    name="infoDescription"
                    :info-description="infoDescription"
                >
                    <span
                        v-if="infoDescription !== ''"
                    >
                        {{ infoDescription }}
                    </span>
                </slot>
                <slot
                    name="secondaryInfo"
                    :secondaryInfo="secondaryInfo"
                >
                    <template v-if="secondaryInfo !== ''">
                        <span class="StatCard__secondary-info">{{ secondaryInfo }}</span>
                    </template>
                </slot>
            </div>
        </template>
    </RPBaseStatCard>
</template>
<script>
import RPBaseStatCard from './RPBaseStatCard.vue';
import stat from 'status';

export default {
    name: 'RPStatCard',
    components: {
        RPBaseStatCard
    },
    props: {
        title: {
            type: String,
            default: 'Default Title'
        },
        borderColor: {
            type: String,
            default: ''
        },
        primaryInfo: {
            type: [String, Number],
            default: 'Primary Info'
        },
        infoDescription: {
            type: String,
            default: ''
        },
        secondaryInfo: {
            type: [String,],
            default: ''
        },
        cardLink: {
            type: String,
            default: '',
        },
        cardLinkText: {
            type: String,
            default: 'Report',
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
        background: {
            type: String,
            default: 'white'
        }
    },
};
</script>
<style lang="scss">
    .StatCard {
        flex-grow: 1;
        padding: 0 1rem 1rem 1rem;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: space-between;
        text-align: center;
        &__primary-info {
            color: $text-dark;
            margin-bottom: 0.5rem;
            flex-grow: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
        &__description{
            margin-bottom: 0.25rem;
        }
        &__secondary-info {
            font-size: 0.8rem;
            color: $text-grey;
            &:not(:last-child){
                margin-bottom: 0.25rem;
            }
        }
    }
</style>
